import Vue from "vue"
import VueRouter from "vue-router"
import Store from "@/store/index.js"
import updateMenuService from "@/common/updateMenu.js"
Vue.use(VueRouter)

// 管理平台路由
import managerModel from "./managerModel.js"

const routes = [
  managerModel,
  {
    path: "*",
    component: () => import("@/components/common/404.vue")
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    // 切换路由，使页面滚动到顶部的hack方式
    try {
      document.querySelector(".el-main .topDom").scrollIntoView()
    } catch (error) {
      console.log(error)
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.name === "Home") {
    // 如果跳转到根路径了，则进一步判断是否有管理员权限，跳转到不同的默认路径
    if (router.app.$keycloak.hasRealmRole("admin")) {
      next("/userManage")
    } else {
      next("/portalApplication")
    }
  } else {
    // 如果想去的路由有meta.requiresAuth字段，代表是管理员模式
    if (to.matched.some(record => record.meta.requiresAuth)) {
      sessionStorage.setItem("currentModel", "manager")
      Store.commit("change_model", "manager")
      // 如果有管理员权限，则继续，否则跳转根路径
      if (router.app.$keycloak.hasRealmRole("admin")) {
        next()
      } else {
        const loginUrl = "/"
        window.location.replace(loginUrl)
      }
    } else {
      // 代表想去的路由是用户模式
      sessionStorage.setItem("currentModel", "user")
      Store.commit("change_model", "user")
      next()
    }
  }
  // updateMenuService()
  updateMenuService(router.app.$keycloak)
})
export default router
